export default "__VITE_ASSET__pM2QSfvA__"